import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import { Formik, Form, Field } from 'formik';
import {  LinearProgress } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import { DatePicker } from 'formik-material-ui-pickers';
import { TimePicker } from 'formik-material-ui-pickers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import emailjs from 'emailjs-com';



const initialvalue = {
    Name:'',
    email: '',
    mobile:'',
    Date:'2020-10-28T15:11:00.000Z',
    Time:'2020-10-27T13:55:53.211Z',
    Course:''


}
const vaidation = yup.object({
    email: yup.string().email().required("Required"),
    mobile:yup.number().required("Required"),
})








const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const Formmodel =(props)=>{
 const [open, setOpen] = React.useState(true);



  const handleClose = () => {
    setOpen(false);
    props.setmodelstate(false);
  };

   
  const onsubmit = (value,{ setSubmitting }) => {
    value.Course=props.course;
    console.log(JSON.stringify(value));
    emailjs.send('service_6y2mjlf', 'template_cksp9hm', value, 'user_CdsZNWus1e4JaXE0ZmevR')
    .then((result) => {
        setSubmitting(false);
        props.setOpensuccess(true);
        console.log(result.text);
        handleClose();
    }, (error) => {
        props.setOpenerror(true);
        console.log(error.text);
        setSubmitting(false);
        handleClose();
    });    
   
}

  return (
    <div>
     
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Webinar"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
          Apply for Weekend webinar sessions ,select the timings and i will
           contact  you
          </DialogContentText>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Formik
            initialValues={initialvalue}
            validationSchema={vaidation}
            onSubmit={onsubmit
            }

        >{

            formik=>{
              
                return(
     
                    <Form >
                        <Field
                            component={TextField}
                            name="Name"
                            type="text"
                            label="Name"
                            fullWidth
                        /><br />
                        <Field
                            component={TextField}
                            name="email"
                            type="email"
                            label="Email"
                            fullWidth
                        />
                        <br />
                        <Field
                            component={TextField}
                            name="mobile"
                            type="text"
                            label="mobile"
                            fullWidth
                        />
                      
                        <br></br>
                        <Field component={DatePicker} label="Date" name="Date" fullWidth/>
                        <br></br>
                        <Field component={TimePicker} label="Time" name="Time" fullWidth/>
                        <br></br>
                        {formik.isSubmitting && <LinearProgress />}
                        <br />
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={formik.isSubmitting}
                            onClick={formik.submitForm}
                        >
                            Join
              </Button>
                    </Form>
                )}
        }
        
           
        </Formik>
        </MuiPickersUtilsProvider>
        </DialogContent>
        <DialogActions>
        
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Formmodel